export const ACTION_DETAILS = 'details';
export const ACTION_IPG = 'IPG';
export const ACTION_POWER = 'power';
export const ACTION_CONSUMPTION = 'consumption';
export const ACTION_CONSUMPTION_MONTHLY = 'consumption_monthly';
export const ACTION_SLOTS = 'slots';



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/actions.js